import { yup } from '@guiker/yup-util'

export const email = yup.string().trim().email().required()
